import { render, staticRenderFns } from "./CheckSmall.vue?vue&type=template&id=30c10ab1"
import script from "./CheckSmall.vue?vue&type=script&lang=js"
export * from "./CheckSmall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports